import styled from '@emotion/styled';

export const S = {
  Container: styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: '1.5rem',
  }),

  Message: styled.p({
    fontSize: '1rem',
    color: '#666',
  }),
} as const;
